export default __webpack_public_path__ + "static/media/Snd4.4d213707.mp3";